
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1.682","y":"1.082","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M1.182 17.082a.5.5 0 000 1v-1zm12.353.854a.5.5 0 000-.707l-3.182-3.182a.5.5 0 10-.707.707l2.829 2.828-2.829 2.828a.5.5 0 10.707.708l3.182-3.182zm-12.353.146h12v-1h-12v1z","fill":"currentColor"}})])
          )
        }
      }
    